import config from 'config'

export default {
  endpoints: {
    loginWithToken: `${config.resourceHost}session/create/token`,
  },
}
